import { Api } from '../api';
import { auth } from '../endpoints';
import type { ApiResponse } from '../../models';
import type { AuthenticateRequest, AuthResponse, RefreshTokenRequest } from './models';

export class AuthApi extends Api {
  static authenticate = async (request: AuthenticateRequest) => {
    const result = await this.post<AuthenticateRequest, ApiResponse<AuthResponse>>({ url: auth.authenticate(), data: request });
    return result.data;
  };

  static refreshToken = async (request: RefreshTokenRequest) => {
    const result = await this.post<RefreshTokenRequest, ApiResponse<AuthResponse>>({ url: auth.refreshToken(), data: request });
    if (!result.data?.refreshToken) result.data!.refreshToken = request.refreshToken;
    return result.data!;
  };
}
